import { render, staticRenderFns } from "./ModerationAppeal.vue?vue&type=template&id=1de5e9c9&scoped=true&"
import script from "./ModerationAppeal.vue?vue&type=script&lang=js&"
export * from "./ModerationAppeal.vue?vue&type=script&lang=js&"
import style0 from "./ModerationAppeal.vue?vue&type=style&index=0&id=1de5e9c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5e9c9",
  null
  
)

export default component.exports